import { ChartFrequency, ISubmissionAnalyticsPayload } from 'wisestep-api';

import IAnalyticsJobSearchFilterDTO from '../../../features/analytics/jobsAnalyticsSearchFilter/IAnalyticsJobSearchFilterDTO';
import { IBusinessData } from '../../../features/crmSettings/customizeStageStatus/helper';

export interface ICallsMadeByStatus {
  createdBy: string;
  totalCalls: number;
  statusWithCount: { key: string; value: number };
  direction: string;
  source: string;
}
export enum ChartScope {
  WORKSPACE = 'workspace',
  TEAMS = 'teams',
  LOGGED_IN_USER = 'loggedInUser',
  LOGGED_IN_USER_MODIFIED_BY = 'loggedInUser_modifiedBy',
}

export enum DataSource {
  ES = 'ES',
  POSTGRE = 'PG',
}

export interface ICallsByStatusResponse {
  calls: ICallsMadeByStatus[];
  statuses: string[];
}

export interface IAnalyticsBaseChartsProps<T> {
  query?: T;
  title: string;
  abstractQuery: IAnalyticsAbstractQuery<T>;
}

export interface ISubmissionAnalyticsProps {
  query: ISubmissionAnalyticsPayload;
  title: string;
}
export interface IAnalyticsBusinessDefinitionBaseChartsProps<T> {
  query?: T;
  title: string;
  abstractQuery: IAnalyticsAbstractQuery<T>;
  businessDefinition?: IBusinessData;
}
export interface IAnalyticsJobsChartsProps<T> {
  query?: T;
  title: string;
  abstractQuery: IAnalyticsAbstractQuery<T>;
  isForJobType?: boolean;
}

export interface IAnalyticsSubmissionsCandidateStatusChartsProps<T> {
  query?: T;
  title: string;
  abstractQuery: IAnalyticsAbstractQuery<T>;
  candidateStatus: string;
}

export type IAnalyticsDerivedChartsQueryProp<T> = Partial<IAnalyticsBaseChartsProps<T>>;

export interface IJobsChartsQueryProp {
  query: IAnalyticsJobSearchFilterDTO;
}
export type IAnalyticsAbstractQuery<T> = Partial<T> & {
  scope?: ChartScope;
  frequency?: ChartFrequency;
};

export interface IAggregations {
  firstBucketKey: string;
  secondBucketKey: string;
  resultWithCount: { key: string; value: number };
  total: number;
}
export interface ICvViewTimeStamp {
  jobBoard: string;
  totalCvView: number;
  timeStampWithCount: { key: string; value: number };
}
export interface ICvViewTablesByTimeStamp {
  cvView: ICvViewTimeStamp[];
  timeStamp: string[];
}
export interface IPipelineJobTitleStage {
  jobtitle: string;
  count: number;
  stageWithCount: { key: string; value: number };
}

export interface IPipelineJobTitleStageTable {
  jobTitleObj: IPipelineJobTitleStage[];
  distinctResultStages: string[];
}

export interface ICvViewJobBoardsCount {
  recruiterName: string;
  totalCvView: number;
  jobBoardWithCount: { key: string; value: number };
}

export interface ICvViewJobBoardsRecruiterTable {
  recruiterObj: ICvViewJobBoardsCount[];
  distinctResults: string[];
}

export interface ITwoLevelAggregationForSimpleData {
  aggregation1?: string;
  aggregation2?: string;
  count?: number;
}

export interface ITwoLevelAggregation {
  aggregation1?: string;
  aggregation2?: string;
  count?: number;
  aggregation2WithCount: { key: string; value: number };
}

export interface IApplicationReceivedJobBoardsRecruiterTable {
  recruiterObj: ITwoLevelAggregation[];
  distinctResults: string[];
}

export interface IFollowupsStatusRecruiterTable {
  recruiterObj: ITwoLevelAggregation[];
  distinctResults: string[];
}
export interface IJobsStatusSplitTable {
  statusObj: ITwoLevelAggregation[];
  distinctResults: string[];
}

export const StandardHeightsByRows = {
  3: '300px',
  5: '404px',
  10: '670px',
};
